import React from 'react';
import useTranslation from '../../../hooks/use-translation';
import { TextualSeparator } from './TextualSeparator';
const ResponseTime = ({ responseDuration }) => {
    const { translate } = useTranslation();
    const ResponseTimeElement = (React.createElement("div", { className: 'd-flex flex-column fs-4 align-items-center justify-content-center w-100 p-2 my-2' },
        React.createElement("div", { className: 'text-dark d-flex text-center fw-bold' },
            React.createElement("div", { className: 'p-1 text-white rounded-circle mx-2', style: { backgroundColor: '#1F8F84', height: "26px", width: "26px" } },
                React.createElement("i", { className: "fa-solid fa-bolt text-white fs-5" })),
            translate("response_time")),
        React.createElement("div", { className: 'text-dark text-center' }, translate("response_estimated", [responseDuration]))));
    return React.createElement(TextualSeparator, { data: ResponseTimeElement });
};
export default ResponseTime;
